import React from "react";

import WComponent from "../common/WComponent";
import ToolsSelect from "../clients/Tools/kit/ToolsSelect";
import PlaybookReviewService from "../../services/PlaybookReviewService";

import "./playbook-decision-form.css";

const CHOICE_WORDS = {
	account: {
		acceptLabel: "Which account does it belong in?",
		placeholder: "Choose the right account…",
		searchPlaceholder: "Search the chart of accounts",
		acceptButton: "Accept with this account",
	},
	list: {
		acceptLabel: "Which is right?",
		placeholder: "Choose the right answer…",
		searchPlaceholder: "Search the answers",
		acceptButton: "Accept with this answer",
	},
};

class PlaybookDecisionForm extends WComponent {
	constructor(props) {
		super(props);
		this.state = {
			chosenId: "",
			reasonCategory: "",
			reason: "",
		};
	}

	onSave = () => {
		const { chosenId, reasonCategory, reason } = this.state;
		const chosenValue = chosenId ? { choiceId: chosenId } : null;
		this.props.onSave({ reasonCategory, reason: reason.trim(), chosenValue });
	};

	renderChoice() {
		const { choices, isRejection } = this.props;
		const { chosenId } = this.state;
		if (!choices) return null;
		const words = CHOICE_WORDS[choices.kind] || CHOICE_WORDS.list;

		return (
			<div className="tk-form-field playbook-decision-form__field">
				<div className="tk-form-label">{isRejection ? "Change to" : words.acceptLabel}</div>
				<ToolsSelect
					value={chosenId}
					options={choices.options}
					onChange={value => this.update({ chosenId: value })}
					placeholder={words.placeholder}
					searchable
					searchPlaceholder={words.searchPlaceholder}
				/>
			</div>
		);
	}

	renderWhy({ isNoteRequired }) {
		const { reasonCategory, reason } = this.state;
		return (
			<div className="tk-form-field playbook-decision-form__field">
				<div className="tk-form-label">Why</div>
				<div className="playbook-decision-form__why">
					<div className="playbook-decision-form__reason">
						<ToolsSelect
							value={reasonCategory}
							options={PlaybookReviewService.rejectReasonChoices()}
							onChange={value => this.update({ reasonCategory: value })}
							placeholder="Choose a reason…"
						/>
					</div>
					<input
						className="tk-input playbook-decision-form__note"
						value={reason}
						onChange={event => this.update({ reason: event.target.value })}
						placeholder={isNoteRequired ? "Say why in a sentence" : "Add a note (optional)"}
						maxLength={1000}
					/>
				</div>
			</div>
		);
	}

	render() {
		const { choices, isRejection, isBusy, onBack } = this.props;
		const { chosenId, reasonCategory, reason } = this.state;
		const readiness = PlaybookReviewService.describeDecisionReadiness({ isRejection, reasonCategory, reason, choices, chosenId });
		const words = choices ? CHOICE_WORDS[choices.kind] || CHOICE_WORDS.list : CHOICE_WORDS.list;

		return (
			<div className="playbook-decision-form">
				{this.renderChoice()}
				{isRejection && this.renderWhy({ isNoteRequired: readiness.isNoteRequired })}
				<div className="playbook-decision-form__actions">
					<button
						type="button"
						className="tk-button tk-button--primary tk-button--compact"
						onClick={this.onSave}
						disabled={!readiness.isReady || isBusy}
					>
						{isRejection ? "Save rejection" : words.acceptButton}
					</button>
					<button type="button" className="tk-text-action tk-text-action--muted" onClick={onBack}>
						Back
					</button>
					{readiness.missing && <span className="playbook-decision-form__missing">{readiness.missing}</span>}
				</div>
			</div>
		);
	}
}

export default PlaybookDecisionForm;
